/**
 * 表示用に文字列を整形する
 */
import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";
import { isEmpty } from "./string";

// 見積したい機器 整形
export const formatSelectKiki = (arr) => {
	var result = "";
	arr.forEach((element, index) => {
		// 最後以外に区切り文字「／」を付与
		arr.length !== index + 1
			? result += element + "／"
			: result += element;
	});

	return result;
}

// お名前 整形
export const formatCustNm = (sei, mei) => {
	var result = sei;
	if (mei) result += "　" + mei

	return result;
}

// 郵便番号 整形
export const formatYubinNo = (yubinNo, isMark) => {
	if (!yubinNo.match(/-/)) {
		yubinNo = yubinNo.slice(0, 3) + "-" + yubinNo.slice(3, 7);
	}

	if (isMark) {
		yubinNo = "〒" + yubinNo;
	}

	return yubinNo;
}

// 住所 整形
export const formatJusyo = (addressKjLabel, bant, go, bldNmKj, muneban, heyaban) => {

	var result = addressKjLabel;

	if (bant) result += " " + bant;
	if (go) result += "-" + go;
	if (bldNmKj) result += " " + bldNmKj;
	if (muneban) result += " " + muneban;
	if (heyaban) result += " -" + heyaban;

	return result;
}

// 電話番号ハイフン付き 整形
export const formatTelNumber = (telNo) => {

	// 電話番号が未入力の場合、処理終了
	if (isEmpty(telNo) || !isFinite(telNo.replace(/-/g, ""))) return null;

	// 日本の国コード
	const region = 'JP';

	const util = PhoneNumberUtil.getInstance();

	// 番号と地域を設定
	const number = util.parseAndKeepRawInput(telNo, region);

	// 電話番号の有効性チェック
	if (!util.isValidNumberForRegion(number, region)) {
		return null;
	}

	// ハイフン付きの形式で返却
	return util.format(number, PhoneNumberFormat.NATIONAL);
};

// チェックボックス選択値を「はい」「いいえ」に変換
export const chgChkValToStr = (value) => {
	return value ? "はい（受信する）" : "いいえ（受信しない）";
};